<template>
	<div class="list_ma">
		<div class="list_box p_flex p_f_a p_b_b" v-for="(item, index) in data.list" :key="index">
			<div class="p_m_l_60 p_f_1">
				<div >
					<div class="p_flex p_f_a ">
						<span class="type_size_18">{{item.type_def}}</span>
						<span class="p_m_l_30">{{item.create_time}}</span>
					</div>
					<span class="p_m_t_14 one-overflow type_size_16">
						{{item.content}}
					</span>
				</div>
			</div>
		</div>
		<div class="p_flex p_f_c p_m_t_20 p_m_b_20" v-if="loading">加载中...</div>
		<div class="" v-if="!noMore"><el-divider>没有更多了</el-divider></div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			count: 10,
			loading: true,
			noMore: true,
			data: { count:0, list:[] },
			postData: { page:1, limit: 3 },
		};
	},
	computed: {

	},
	mounted() {
		this.getList()
		var _this = this
		this.$nextTick(() => {
			var el = document.querySelector('.other_news_list');
			var offsetHeight = el.offsetHeight;
			el.onscroll = () => {
				var scrollTop = el.scrollTop;
				var scrollHeight = el.scrollHeight;
				if ((offsetHeight + scrollTop) - scrollHeight >= -1) {
					if( _this.noMore ){
						_this.postData.page = _this.postData.page+1
						_this.getList()
					}
				}
			};
		});
	},
	methods: {
		getList(){
			this.loading = true
			this.$request.ajax(this).post('api_student/news_other_list',this.postData).then(res=>{
				if(res.data.list.length > 0){
					res.data.list = this.data.list.concat(res.data.list)
					console.log(res.data.list)
					this.data = res.data
				}else{
					this.noMore = false
				}
			})
			this.loading = false
		}
	}
};
</script>

<style lang="scss" scoped>
.list_box {
	padding: 20px 0;
}
.list_ma {
	margin: 0 260px;
}
.list_img {
	width: 60px;
	height: 60px;
}
>>> .el-badge__content {
	background-color: #f1282e;
}
</style>



// WEBPACK FOOTER //
// src/components/homes/news/commponents/restList.vue